/* eslint-disable @typescript-eslint/naming-convention */
import { ClinicalAssessmentTypes } from '@sondermind/utilities/models-assessments-monolith';
import { InPersonWorkingHoursFeatureFlag } from '@sondermind/utilities/models-availability';
import { FeatureFlagKey } from './feature-flag-key.enum';
import { FeatureFlagDefaults } from './feature-flag-types';

/**
 * Feature flag values used in CI environment.
 * Add new flag values here as needed for Cypress tests.
 */
export const FEATURE_FLAG_CI_VALUES: FeatureFlagDefaults = {
  // String flags
  [FeatureFlagKey.IN_PERSON_WORKING_HOURS]: InPersonWorkingHoursFeatureFlag.LEGACY_VIEW,

  // Boolean flags
  [FeatureFlagKey.DIRECT_SCHEDULE_ANY_MATCH]: false,
  [FeatureFlagKey.USE_TREATMENT_PLAN]: true,
  [FeatureFlagKey.OPTIMIZE_ANALYTICS_DASH]: false,
  [FeatureFlagKey.QUICK_CHECKOUT_AUTH0]: false,
  [FeatureFlagKey.NEW_CLIENT_PORTAL]: false,
  [FeatureFlagKey.FILE_UPLOAD_IN_CHAT]: false,
  [FeatureFlagKey.PSYCHIATRY_FLOW_AUTH0]: false,
  [FeatureFlagKey.AUTOMATED_CONSENT_DOCS]: false,
  [FeatureFlagKey.DIRECTORY_HOMEPAGE_REDESIGN]: false,
  [FeatureFlagKey.CREATE_PROVIDER_INVITED_REFERRALS]: false,
  [FeatureFlagKey.NEW_DIRECTORY_HOMEPAGE_FILTERS]: false,
  [FeatureFlagKey.NEW_TOS_MODAL]: false,

  // Structured flags (JSON payloads)
  [FeatureFlagKey.NEW_CQS]: {
    'active-cqs': [
      ClinicalAssessmentTypes.CSSRS_ADULTS,
      ClinicalAssessmentTypes.PROMIS_ANGER,
      ClinicalAssessmentTypes.PROMIS_ANXIETY,
      ClinicalAssessmentTypes.PROMIS_DEPRESSION,
      ClinicalAssessmentTypes.AUDIT_C,
      ClinicalAssessmentTypes.S2BI,
      ClinicalAssessmentTypes.CSSRS_KIDS,
      ClinicalAssessmentTypes.ASRS_A,
      ClinicalAssessmentTypes.ASRS_AB,
      ClinicalAssessmentTypes.WHO_5
    ],
    'show-date-administered': false
  },
  [FeatureFlagKey.REFERRALS_NEW_COMPONENT]: {
    showNewClientReferralsCard: false,
    referralsCardAction: 'Draft message'
  },
  [FeatureFlagKey.SCHEDULING_CTA_THEME]: {
    placement: 'front'
  },
  [FeatureFlagKey.PROVIDER_PORTAL_NEW_IA]: {
    enableNewIA: false,
    allowOldIAToggle: false
  }
};
